import { z } from 'zod';
export const FlowTestStartEntityTypeSchema = z.enum(['ehrInformation']);
export const FlowTestStartEntityType = FlowTestStartEntityTypeSchema.enum;
export const FlowTestStartEntitySchema = z.discriminatedUnion('entityType', [
    z.object({
        entityType: z.literal(FlowTestStartEntityType.ehrInformation),
        /** Present for downstream context consumers but never fetched from the database. */
        entityId: z.uuid(),
        /** Opaque because Primary and FHIR own the authoritative entity shapes. */
        record: z.record(z.string(), z.unknown()),
    }),
]);
/** Excludes organization and practice IDs because those belong to the run rather than the case. */
export const FlowTestStartPayloadSchema = z.object({
    entity: FlowTestStartEntitySchema.optional(),
    /** Uses a string type because flow-api owns the authoritative start-data enum. */
    startData: z
        .object({
        type: z.string().min(1),
        data: z.unknown(),
    })
        .optional(),
});
//# sourceMappingURL=startPayload.js.map